<template>
    <div class="flex flex-col items-start p-8 w-full flex-1">
        <div class="flex-1 w-full flex flex-col">
            <div class="mb-10 w-full">
                <h2 class="font-semibold text-3xl text-neutral-base mb-4">
                    {{ config.layout.title }}
                </h2>
                <h3
                    v-if="config.layout.subtitle"
                    class="font-semibold text-3xl text-neutral-base mb-2"
                >
                    {{ config.layout.subtitle }}
                </h3>
                <p
                    v-if="config.layout.description"
                    class="text-neutral-base text-base"
                >
                    <slot name="description">
                        {{ config.layout.description }}
                    </slot>
                </p>
            </div>
            <div class="w-full flex-1 flex flex-col">
                <slot />
            </div>
        </div>
        <Teleport :to="footerMenu?.$el">
            <div class="pb-(--beyond-safe-area-inset-bottom) px-8 flex flex-col w-full mt-auto">
                <div
                    class="pb-4"
                    data-cy="tour-footer"
                >
                    <DButton
                        class="mb-1"
                        wide
                        :disabled="disabled"
                        @click="emit('action-completed')"
                    >
                        {{ config.action_button_text }}
                    </DButton>

                    <DButton
                        v-if="showSkipButton"
                        class="mb-1"
                        theme="transparent"
                        wide
                        @click="emit('action-skipped')"
                    >
                        {{ config.skip_step_button_text }}
                    </DButton>
                </div>
            </div>
        </Teleport>
    </div>
</template>

<script setup>
    import { DButton } from '@digistorm/spark'

    const emit = defineEmits(['action-completed', 'action-skipped'])

    const props = defineProps({
        config: Object,
        disabled: Boolean,
        showSkipButton: Boolean,
    })

    const footerMenu = inject('footerMenu', null)
</script>
